import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const styles = theme => ({
    root: {
        position: props => props.absolute ? 'absolute' : 'sticky',
        top: props => props.y,
        right: '50%',
        transform: 'translateX(-50%)',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            top: props => props.yMobile
        }
    }
})

const useStyles = makeStyles(styles)

export default function AssignId({ id, y, yMobile, absolute }) {
    const props = { y, yMobile, absolute }
    const classes = useStyles(props)
    return <span className={classes.root} id={id} ></span>
}
